import { Box, Theme, Typography } from "@outschool/backpack";
import { ClassDetailsQuery_ActivityFragment } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { LazyBox } from "@outschool/ui-components-shared";
import { Container, Loading } from "@outschool/ui-legacy-component-library";
import React, { Dispatch, RefObject, SetStateAction } from "react";

import HeadingMarker from "../subcomponents/HeadingMarker";
import PublicReviewsOfActivity, {
  TabValue,
} from "../subcomponents/PublicReviewsOfActivity";

interface ClassDetailsReviewsProps {
  activity: ClassDetailsQuery_ActivityFragment;
  reviewsRef: RefObject<HTMLElement>;
  setTabValue: Dispatch<SetStateAction<TabValue>>;
  tabValue: TabValue;
}

export function ReviewsSection({
  activity,
  reviewsRef,
  setTabValue,
  tabValue,
}: ClassDetailsReviewsProps) {
  const { t } = useTranslation(
    "client\\components\\detailPage\\ClassDetailsMainBody\\ClassDetailsReviews",
  );
  return (
    <Box
      flex
      sx={{
        flexDirection: "column",
        marginTop: 0,
      }}
    >
      <Box
        flex
        sx={{
          flexDirection: "column",
        }}
        ref={reviewsRef}
      >
        <HeadingMarker />
        <Typography
          variant="h4"
          id="reviews"
          sx={(theme: Theme) => ({
            fontWeight: 700,
            marginBottom: "1.2rem",
            [theme.breakpoints.down("md")]: {
              marginBottom: 0,
            },
          })}
        >
          {t("Reviews")}
        </Typography>
        <LazyBox
          placeholder={
            <Container size="small">
              <Loading />
            </Container>
          }
        >
          <PublicReviewsOfActivity
            activity={activity}
            tabValue={tabValue}
            setTabValue={setTabValue}
          />
        </LazyBox>
      </Box>
    </Box>
  );
}
